import { Role } from "src/app/_models/Role";

export interface RoleState{
  loading: boolean;
  list: Role[];
  error: any;
}

export const initializeRoleState: RoleState = {
  loading: false,
  list: [],
  error: null
}